import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { useAuth } from "@/contexts/AuthContext";
import { detectLocalCurrency, setViewCurrency, setViewRates, viewCurrency } from "@/lib/currency";
import { Coins } from "lucide-react";

/** Header currency switcher. Loads world FX rates once; defaults to the signup country's currency, then auto-detect. */
export function CurrencySwitcher() {
  const { user } = useAuth();
  const [codes, setCodes] = useState([]);
  const [code, setCode] = useState(viewCurrency() || "");

  useEffect(() => {
    api.get("/currencies").then(({ data }) => {
      setViewRates(data.view_rates);
      setCodes(Object.keys(data.view_rates || {}).sort());
      if (!localStorage.getItem("vsk_view_currency")) {
        const c = (user?.currency && data.view_rates?.[user.currency]) ? user.currency : detectLocalCurrency();
        setViewCurrency(c); setCode(c);
      }
    }).catch(() => {});
  }, [user?.currency]);

  const change = (c) => { setViewCurrency(c); setCode(c); window.dispatchEvent(new Event("vsk-currency-changed")); };
  if (!codes.length) return null;
  return (
    <label className="hidden sm:inline-flex items-center gap-1 text-xs text-neutral-300" title="Show prices in" data-testid="currency-switcher">
      <Coins className="h-3.5 w-3.5 text-neutral-500" />
      <select value={code} onChange={(e) => change(e.target.value)} data-testid="currency-select" className="bg-transparent border-0 text-xs text-neutral-300 focus:outline-none cursor-pointer">
        {codes.map((c) => <option key={c} value={c} className="bg-[#0A0A0A]">{c}</option>)}
      </select>
    </label>
  );
}
